import { z } from 'zod'

import { adUnitsAttributesSchema } from 'features/inventory/domain/components/ProductAdUnitsTable'
import { Domain } from 'features/inventory/types/domain'

export const schema = z
  .object({
    domainId: z.string(),
    priceGeniusEnabled: z.boolean(),
    sendFloorsToPrebidFloorPriceModule: z.boolean(),
    trafficPercent: z.number().int().min(0).max(100),
  })
  .extend(adUnitsAttributesSchema.shape)

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  domainPriceGenius: { priceGeniusEnabled, sendFloorsToPrebidFloorPriceModule, trafficPercent },
  id,
}: Domain): Schema => ({
  adUnitsAttributes: {},
  domainId: id,
  priceGeniusEnabled,
  sendFloorsToPrebidFloorPriceModule,
  trafficPercent,
})
